exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.page-title[data-v-8d64cf68] {\n  font-size: 0.26rem;\n  color: #000;\n  font-weight: bold;\n  margin-bottom: 0.24rem;\n}\n.goback[data-v-8d64cf68] {\n  width: 0.2rem;\n  height: 0.2rem;\n  margin-right: 10px;\n  cursor: pointer;\n}\n", ""]);

// exports
